// Destination comes from the deployment, never from a query parameter.
export function bridgeContext(search, configuredOrigin) {
    const origin = new URL(configuredOrigin);
    if (origin.protocol !== 'https:' || origin.username || origin.password || origin.pathname !== '/' || origin.search || origin.hash) {
        throw new Error('Invalid Soroban ID configuration');
    }
    const query = new URLSearchParams(search);
    const txn = query.get('txn');
    const state = query.get('state');
    if (!/^[A-Za-z0-9_-]{16,64}$/.test(txn || '') || !/^[A-Za-z0-9_-]{43}$/.test(state || '')) {
        throw new Error('Invalid sign-in request');
    }
    const callback = new URL('/oauth/bridge/callback', origin);
    callback.searchParams.set('txn', txn);
    callback.searchParams.set('state', state);
    return { origin: origin.origin, txn, state, callback };
}

export async function panelSessionBridge(context, user, apiOrigin, fetcher = fetch) {
    // Always use the owner's session, never the emulation stack.
    if (!user?.loggedin || !user.refresh_token) return context.callback.toString();
    const timedFetch = async (url, options) => {
        const abort = new AbortController();
        const timeout = setTimeout(() => abort.abort(), 5000);
        try {
            return await fetcher(url, { ...options, signal: abort.signal, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer' });
        } finally {
            clearTimeout(timeout);
        }
    };
    const ticketFor = token => timedFetch(context.origin + '/oauth/bridge/ticket', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ txn: context.txn, state: context.state, panel_refresh: user.refresh_token }),
    });
    try {
        let result = user.access_token ? await ticketFor(user.access_token) : null;
        if (!result || result.status === 401) {
            const resumed = await timedFetch(apiOrigin.replace(/\/$/, '') + '/auth/resume', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh_token: user.refresh_token }),
            });
            if (resumed.ok) {
                const body = await resumed.json();
                const token = body?.payload?.token;
                if (body.status && typeof token === 'string') result = await ticketFor(token);
            }
        }
        if (result?.ok) {
            const { ticket } = await result.json();
            if (/^[A-Za-z0-9_-]{43}$/.test(ticket || '')) context.callback.searchParams.set('ticket', ticket);
        }
    } catch {
        // An unavailable or expired panel session must not block normal login.
    }
    return context.callback.toString();
}
